import { styled } from '@mui/material/styles';
import Tab, { tabClasses } from '@mui/material/Tab';

const StyledTab = styled(Tab)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '1.375',
  [`&.${tabClasses.selected}`]: {
    color: theme.palette.primary.dark,
    fontWeight: 600,
  },
}));

export default StyledTab;
